module.exports = __webpack_public_path__ + "static/media/icon_value.3400f23e.png";